import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Header from "../components/Header";
import ProductStatusReportTableContent from "../components/reports/ProductStatusReportTableContent";

const ReportsPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const renderTabContent = () => {
    switch (activeIndex) {
      case 0:
        return <ProductStatusReportTableContent />;
      default:
        return <ProductStatusReportTableContent />;
    }
  };

  return (
    <div className={`h-screen py-4 pr-4`}>
      <div className="p-4 rounded-3xl h-full bg-[#ffeded]">
        <div className="flex flex-col justify-between h-full">
          <Header title={"Reports"} />
          <div className={`w-full h-full rounded-2xl m-2 px-0`}>
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Products Delivery Status">
                {activeIndex === 0 && renderTabContent()}
              </TabPanel>
            </TabView>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsPage;
